import { gql } from '@apollo/client'

export const ME_QUERY = gql`
  query Me {
    me {
      roles
      permissions
      apiToken
      email
      name
      companyName
      id
      freeTrialRemainingDays
    }
  }
`
